import { mixpanel } from '@fiverr-private/obs';
import { getDataFromStores } from '../../../../shared/utils';
import store from '../../store';

export const reportForkingPointView = () => {
    mixpanel.track(
        'Logo Maker - MP Forking Point - View',
        getDataFromStores(
            store.searchQuery,
            store.sourcePage,
            store.listingsType
        )
    );
};
